import React, { useContext, useEffect, useCallback, useRef } from 'react'
import gsap from 'gsap'
import PropTypes from 'prop-types'
import { StoreState } from '../../Store'

// SVGs
import ExpeditionRouteCircle from '../svgs/ExpeditionRoutes/border'
import ExpeditionRouteMarker from '../svgs/ExpeditionRoutes/marker'
import ExpeditionRoute1 from '../svgs/ExpeditionRoutes/3/1'
import ExpeditionRoute4 from '../svgs/ExpeditionRoutes/3/4'

// Styles
import {
  SingleRouteMain,
  SingleRoutePath,
  SingleRouteLabel,
  SingleRouteLocation,
  SingleRoutePhoto,
} from './index.style'

// Images
import Colosseum from '../Map/assets/locations/colosseum.jpg'

const Route3 = ({ id, backgroundColor, labelColor }) => {
  const store = useContext(StoreState)
  const { waiting } = store

  const routeIn = useRef()

  const line1Ref = {
      line: useRef(),
      arrow: useRef(),
    },
    line4Ref = {
      line: useRef(),
    },
    circle3Ref = useRef(),
    photo3Ref = useRef(),
    label3Ref = useRef()

  const play = useCallback(() => {
    routeIn.current.play(0)
  }, [routeIn])

  useEffect(() => {
    if (!waiting) setTimeout(play, 500)
  }, [waiting, play])

  useEffect(() => {
    if (routeIn.current) return

    routeIn.current = gsap.timeline({
      paused: true,
    })

    routeIn.current.to(line1Ref.line.current, {
      ease: 'power1.inOut',
      strokeDashoffset: 1346,
      duration: 4,
    })

    routeIn.current.to(
      line1Ref.arrow.current,
      {
        ease: 'power2.out',
        opacity: 1,
        duration: 0.4,
      },
      '=-.3'
    )

    routeIn.current.addLabel('location1', '-=.5')

    routeIn.current.to(
      circle3Ref.current,
      {
        ease: 'power2.inOut',
        strokeDashoffset: 0,
        duration: 1.5,
      },
      'location3'
    )

    routeIn.current.to(
      photo3Ref.current,
      {
        ease: 'power1.inOut',
        opacity: 1,
        duration: 1,
      },
      'location3+=.5'
    )

    routeIn.current.to(
      label3Ref.current,
      {
        ease: 'power2.out',
        opacity: 1,
        y: 0,
        duration: 0.8,
      },
      'location3+=.7'
    )

    // Line 4

    routeIn.current.to(
      line4Ref.line.current,
      {
        ease: 'power1.inOut',
        strokeDashoffset: 1238,
        duration: 4.5,
      },
      '=-.6'
    )
  }, [
    routeIn,
    line1Ref.line,
    line1Ref.arrow,
    line4Ref.line,
    line4Ref.arrow,
    circle3Ref,
    photo3Ref,
    label3Ref,
  ])

  return (
    <SingleRouteMain>
      <SingleRoutePath right={0} top={15.4} width={47.1}>
        <ExpeditionRoute1
          forwardRef={line1Ref}
          mask={backgroundColor}
          stroke={labelColor}
        />
      </SingleRoutePath>

      <SingleRouteLocation right={45.4} top={50.9}>
        <SingleRouteLabel ref={label3Ref} left={true} color={labelColor}>
          The Colosseum <ExpeditionRouteMarker fill={labelColor} />
        </SingleRouteLabel>
        <ExpeditionRouteCircle
          forwardRef={circle3Ref}
          stroke={labelColor}
          rotation={29}
        />
        <SingleRoutePhoto ref={photo3Ref} bgImage={Colosseum} />
      </SingleRouteLocation>
      <SingleRoutePath right={50.6} top={21.5} width={48}>
        <ExpeditionRoute4
          forwardRef={line4Ref}
          mask={backgroundColor}
          stroke={labelColor}
        />
      </SingleRoutePath>
    </SingleRouteMain>
  )
}

Route3.propTypes = {
  id: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  labelColor: PropTypes.string,
}

export default Route3
